import { useEffect, useState } from 'react';

const useDelayHiding = (showing, animation) => {
  const [animate, setAnimate] = useState(false);
  const [localVisible, setLocalVisible] = useState(showing);

  const [renderable, setRenderable] = useState(false);

  useEffect(() => {
    if (localVisible && !showing) {
      setAnimate(true);
      setTimeout(() => setAnimate(false), animation.duration);
    }
    setLocalVisible(showing);
  }, [showing, animation, localVisible]);

  useEffect(() => {
    setRenderable(animate || localVisible);
  }, [localVisible, animate]);

  return renderable;
};

export default useDelayHiding;
